import { z } from "zod";

export const positionSchema = z.object({
  positionName: z.optional(
    z.string().max(255, "Nazwa stanowiska jest zbyt długa")
  ),
});
